import React, { useState } from 'react';
import {
  FaUser,
  FaBell,
  FaFileInvoiceDollar,
  FaCog
} from 'react-icons/fa';
import PerfilCliente from './PerfilCliente';
import Notificaciones from './Notificaciones';
import Facturacion from './Facturacion';
import Configuraciones from './Configuraciones';
import styles from './ClienteArea.module.css';

export default function ClienteArea() {
  const [activeSection, setActiveSection] = useState('perfil');

  const menuItems = [
    { id: 'perfil', label: 'Mi Perfil', icon: <FaUser /> },
    { id: 'notificaciones', label: 'Notificaciones', icon: <FaBell /> },
    { id: 'facturacion', label: 'Facturación', icon: <FaFileInvoiceDollar /> },
    { id: 'config', label: 'Otras Configuraciones', icon: <FaCog /> }
  ];

  return (
    <div className={styles['area-cliente-wrapper']}>
      <aside className={styles.sidebar}>
        <nav>
          <ul className={styles.menuList}>
            {menuItems.map(({ id, label, icon }) => (
              <li
                key={id}
                className={`${styles.menuItem} ${activeSection === id ? styles.active : ''}`}
                onClick={() => setActiveSection(id)}
                tabIndex={0}
                role="button"
                onKeyDown={(e) => { if (e.key === 'Enter') setActiveSection(id) }}
              >
                <span className={styles.icon}>{icon}</span>
                <span>{label}</span>
              </li>
            ))}
          </ul>
        </nav>
      </aside>

      <main className={styles.mainContent}>
        <header className={styles.header}>
          <h1>{menuItems.find(item => item.id === activeSection)?.label}</h1>
        </header>
        <section className={styles.contentArea}>
          {activeSection === 'perfil' && <PerfilCliente />}
          {activeSection === 'notificaciones' && <Notificaciones />}
          {activeSection === 'facturacion' && <Facturacion />}
          {activeSection === 'config' && <Configuraciones />}
        </section>
      </main>
    </div>
  );
}
